import { END, buffers, eventChannel } from "redux-saga";
import {
    all, call, cancelled, put, take, takeEvery 
} from "redux-saga/effects";

import fonts from "./theme/constants/fonts.json";

import { ONE_SECOND } from "./constants/constants";

import { markFontsAsLoaded, markPageVisible } from "./global.duck";

//const scopeAction = (actionCreator, scope) => data => ({
//    ...actionCreator(data),
//    meta: { scopeID: scope }
//});



// In SSR, window is not defined
const allFontsLoadedFn = async () => {
    if(!window) return;
    const { default: FontFaceObserver } = await import("fontfaceobserver");
    const promises = Object.values(fonts).map(
        ({ family, weight, style }) =>
            new FontFaceObserver(family, { weight, style })
    );
    for (const promise of promises) {
        await promise;
    }
    return;
};
const pageVisibilityChange = () => {
    return eventChannel(emitter => {
        // Set the name of the hidden property and the change event for visibility
        let hidden, visibilityChange;
        if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        }

        // Warn if the browser doesn't support addEventListener or the Page Visibility API
        if (typeof document.addEventListener === "undefined" || hidden === undefined) {
            console.warn("VisibilityChange observation requires a browser that supports the Page Visibility API.");
            emitter(END);
        } else {
            // Handle page visibility change
            const handleVisibilityChange = () => {
                emitter({ isVisible: Document.visibilityState === "visible" || !document[hidden] });
            };
            document.addEventListener(visibilityChange, handleVisibilityChange, false);
            emitter({ isVisible: Document.visibilityState === "visible" || !document[hidden] }); // init
            return () => document.removeEventListener(visibilityChange, handleVisibilityChange, false);
        }
        return () => null;
    },
    buffers.sliding(1) // buffer one invocation holding the most recent event
    );
};

function* pageVisibilitySaga() {
    const chan = yield call(pageVisibilityChange);
    try {
        while (true) {
            // take(END) will cause the saga to terminate by jumping to the finally block
            const { isVisible } = yield take(chan);
            yield put(markPageVisible(isVisible));

            //yield put(readyAction(markPageVisible)(isVisible));
        }
    } finally {
        if (yield cancelled()) {
            chan.close();
        }
    }
    
}

function* fontLoadSagaSaga() {
    yield call(allFontsLoadedFn);
    yield put(markFontsAsLoaded());
}



// const delay = ms => new Promise(res => setTimeout(res, ms));

//function* () {
//    yield delay(ONE_SECOND);
//    yield put({ type: "INCREMENT" });
//}

//function* watchIncrementAsync() {
//    yield takeEvery("INCREMENT_ASYNC", incrementAsync);
//}

export default () => function* rootSaga() {
    yield all([/* watchIncrementAsync(), */ pageVisibilitySaga(), fontLoadSagaSaga() ]);
};
